import { loginUserReducer, mutltiOrgReducer } from "../slices/authSlice";
import { authApi } from "../../utils/api";
import { BASE_URL } from "../../constants";
import {
  FailureToast,
  InfoToast,
  SuccessToast,
} from "../../utils/commonunctions";
import Cookies from "js-cookie";
import { storeUserSession } from "../../utils/helperdata";
import { fetchFilterGroupAPI, userDetailsApi } from "./UserAction";

// Login API function to authenticate the user and store session data
export const handleLoginAPi = (navigate, data, setOpen, setMultiOrg) => {
  return async (dispatch) => {
    dispatch(loginUserReducer({ singInLoading: true }));

    await authApi
      .post(`${BASE_URL}/api/token/`, data) // sending login credentials
      .then((res) => {
        if (res.status === 200) {
          // On successful login
          storeUserSession(
            res?.data?.username,
            res?.data?.access,
            res?.data?.email
          );
          Cookies.set("UR", 1, { expires: 370 });
          Cookies.set("accessToken", res?.data?.access, { expires: 370 });
          Cookies.set("refreshToken", res?.data?.refresh, { expires: 370 });

          dispatch(userDetailsApi()); // Fetch profile details
          dispatch(fetchFilterGroupAPI()); // Fetch default group data
          SuccessToast("Logged in Successfully");

          setOpen(false); // Close login modal
          navigate("/"); // Navigate to dashboard or homepage
        } else {
          FailureToast("Unexpected Response From Server.");
        }
        dispatch(loginUserReducer({ singInLoading: false }));
      })
      .catch((error) => {
        // If multiple organizations are returned for the same user
        if (error.status === 300) {
          setMultiOrg(true);
          InfoToast("Multiple organizations found");
          dispatch(
            mutltiOrgReducer({ data: error?.response?.data?.organizations })
          );
        }
        // Handle unauthorized or validation errors
        else if (error.status === 401 || error.status === 400) {
          FailureToast(error.response.data.detail[0]);
        }
        // General error fallback
        else {
          const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "An unknown error occurred";
          FailureToast(errorMessage);
        }
        dispatch(loginUserReducer({ singInLoading: false }));
      });
  };
};

// Forgot password API handler
export const handleForgotApi = (
  setIsLoading,
  values,
  navigate,
  setMultiOrg
) => {
  setIsLoading(true);

  return async (dispatch) => {
    await authApi
      .post(`${BASE_URL}/forgot_password/`, values) // send email for password reset
      .then((res) => {
        if (res?.status === 200) {
          setIsLoading(false);
          SuccessToast(res?.data?.message);
          setTimeout(() => {
            navigate("/"); // Redirect after success
          }, 1000);
        }
      })
      .catch((err) => {
        // If multiple orgs are tied to email
        if (err?.status === 300) {
          setMultiOrg(true);
          dispatch(
            mutltiOrgReducer({ data: err?.response?.data?.organizations })
          );
        }

        setIsLoading(false);
        FailureToast(err?.response?.data?.error);
      });
  };
};
